/* import __COLOCATED_TEMPLATE__ from './messenger-security.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import type PingDomain from 'embercom/models/ping-domain';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    pingDomains: PingDomain[];
  };
}

export default class MessengerSecurity extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: any;
  @service declare store: Store;
  @service declare intercomEventService: any;

  get webIdentityVerified() {
    return this.appService.app.identityVerified;
  }

  get iosIdentityVerified() {
    return this.iosSdkApp?.identityVerified;
  }

  get androidIdentityVerified() {
    return this.androidSdkApp?.identityVerified;
  }

  get noDomainsHaveErrors() {
    return this.args.pingDomains?.every((domain) => !domain.errorCode) ?? true;
  }

  get iosSdkApp() {
    return this.appService.app.iosSdkApps?.firstObject;
  }

  get androidSdkApp() {
    return this.appService.app.androidSdkApps?.firstObject;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::MessengerSecurity': typeof MessengerSecurity;
  }
}
